import { styled } from '@mui/material'

export const Iframe = styled('iframe')`
  border: none;
  display: block;
  overflow: hidden;
  transition: height 0.3s ease;
  width: 100%;
`

export const Root = styled('div')`
  bottom: 0;
  max-height: 100vh;
  min-width: 430px;
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  right: 0;
  z-index: 1000;
`
